module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNmZjkyNzUiIGQ9Ik0xOC4xMjUgMTEuMTI1aC01LjI1di01LjI1YzAtLjQ4My0uMzkyLS44NzUtLjg3NS0uODc1cy0uODc1LjM5Mi0uODc1Ljg3NXY1LjI1aC01LjI1Yy0uNDgzIDAtLjg3NS4zOTItLjg3NS44NzVzLjM5Mi44NzUuODc1Ljg3NWg1LjI1djUuMjVjMCAuNDgzLjM5Mi44NzUuODc1Ljg3NXMuODc1LS4zOTIuODc1LS44NzV2LTUuMjVoNS4yNWMuNDgzIDAgLjg3NS0uMzkyLjg3NS0uODc1cy0uMzkyLS44NzUtLjg3NS0uODc1eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/plus_green.svg
// module id = VqSa
// module chunks = 30